<script>
	import { writable } from 'svelte/store';
	import { pageOffset, universalScroll, toggleUniversalToPageScroll } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _drop;

	export let leftOffset;
	export let topOffset;
	export let speedMultiplier;
	export let index;

	const hidden = writable(false);
	let opacity = 1;

	let animation = (value) => {

		if (!$universalScroll) {
			//return;
		}

		animateElement(value, _drop, (currentPageOffset) => {
			const scrolledStartSectionPercentage = currentPageOffset * 0.6;
			let newY = Math.min(80, scrolledStartSectionPercentage * speedMultiplier);
			newY = newY % 20;
			_drop.style.transform = `translateY(${newY}vh)`;

			const disabled = Math.floor(newY / 5);

			if (disabled >= index) {
				hidden.set(true);
			}
			else {
				hidden.set(false);
			}
		});
	};

	let prepareScene = () => {
		if (!_drop) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);

		hidden.subscribe((state) => {
			opacity = state ? 0 : 1;
		});
	};

	prepareScene();

</script>

<style>
	svg {
		position: absolute;
		top: 100%;
		width: 1em;
		height: auto;
	}
</style>

<svg bind:this={_drop} style="margin-left: {leftOffset}; margin-top: {topOffset}; opacity: {opacity}" viewBox="0 0 25 35" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M23.4845 18.9901C21.1003 12.8564 4.07036 0.248047 4.07036 0.248047C4.07036 0.248047 -1.03862 20.6939 1.00498 27.1685C3.38917 33.3022 10.2011 36.3692 16.3319 34.3246C22.4627 31.9392 25.8687 25.1239 23.4845 18.9901Z" fill="#22398E"/>
</svg>
